var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./bundesbruderSucheShort.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-370e591e\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./bundesbruderSucheShort.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/module_klein/bundesbruderSucheShort.vue
// module id = 260
// module chunks = 15